import { render, staticRenderFns } from "./CRMCreateRecoveryDetail.vue?vue&type=template&id=9cfdbf02&scoped=true"
import script from "./CRMCreateRecoveryDetail.vue?vue&type=script&lang=js"
export * from "./CRMCreateRecoveryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfdbf02",
  null
  
)

export default component.exports